// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"3f021253","288":"60f4e7e4","304":"305075d8","344":"a4aeb81a","392":"f9b207b7","400":"b610fba2","412":"78d736dc","576":"641bda38","688":"64232c60","760":"ed0db090","896":"6ce2606f","916":"37918f8d","984":"6635d103"}[chunkId] + ".chunk.js";
};